export default "__VITE_ASSET__DfT2hJWH__"